module.exports = __webpack_public_path__ + "img/automatic-tran.d30cb03e.png";